export default "__VITE_ASSET__C$oDrkiQ__"